module.exports = __webpack_public_path__ + "static/media/minus_grey.28596ea2.svg";